// extracted by mini-css-extract-plugin
export default {"customSingleValue":"CustomSingleValue_customSingleValue__HGthq","label":"CustomSingleValue_label__I2b1f","description":"CustomSingleValue_description__IzO30"};